module.exports = __webpack_public_path__ + "static/media/sRussell.a65651b9.jpg";